import { render } from "./OTPComponent.vue?vue&type=template&id=735ac386&scoped=true"
import script from "./OTPComponent.vue?vue&type=script&lang=js"
export * from "./OTPComponent.vue?vue&type=script&lang=js"

import "./OTPComponent.vue?vue&type=style&index=0&id=735ac386&scoped=true&lang=css"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735ac386"]])

export default __exports__